// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon-border[data-v-44d43782]{border:1px solid rgba(31,50,119,.35);box-shadow:0 0 6.982px 0 rgba(0,0,0,.05)}.question-mark[data-v-44d43782]{background:linear-gradient(166deg,#00084d -6.27%,#2c4389 106.87%);background-clip:text;-webkit-background-clip:text;-webkit-text-fill-color:transparent}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
